import React from 'react';

import styles from './MobileHeader.module.scss';

type Props = {
  children: React.ReactNode;
};

export const MobileHeaderWrapper: React.FC<Props> = ({ children }) => {
  return <div className={styles.MobileHeader__Wrapper}>{children}</div>;
};
